module.exports = __webpack_public_path__ + "img/scoreImg.b033c8d1.jpg";